import React from 'react';
import LogToolbar from './LogToolbar';

export default function LogPostbacksToolbar(props) {
    return <LogToolbar {...props} kind="postbacks"/>;
}
